import axios, { CreateAxiosDefaults } from 'axios'
import type { AxiosInstance } from 'axios'
import type UserToken from '@/entities/security/UserToken'
import { TokenManager } from '@/entities/security/TokenManager'
import { CSRF_TOKEN_URL } from '@/modules/auth/endpoints'
import { axiosUnauthorizedInterceptorHelper } from '@/entities/security/AxiosUnauthorizedInterceptorHelper'

interface AxiosFactoryParams {
  baseURL: string
}

export default class AxiosFactory {
  static params: CreateAxiosDefaults<AxiosFactoryParams> = {
    baseURL: import.meta.env.VITE_BASE_URL,
  }

  static createAxiosInstance(): AxiosInstance {
    const tokenManager = new TokenManager()
    const token = tokenManager.accessToken
    const axiosInstance = token.tokenExist
      ? AxiosFactory.createAxiosInstanceWithToken(tokenManager.accessToken as UserToken)
      : AxiosFactory.createAxiosInstanceWithoutToken()
    return axiosInstance
  }

  static createAxiosInstanceWithToken(token: UserToken): AxiosInstance {
    const instance = axios.create(this.params)
    instance.defaults.headers.common = {
      'X-Requested-With': 'XMLHttpRequest',
      Authorization: `Bearer ${token.token}`,
    }

    axiosUnauthorizedInterceptorHelper(instance)

    return instance
  }

  static createAxiosInstanceWithoutToken() {
    const instance = axios.create(this.params)
    instance.defaults.headers.common = {
      'X-Requested-With': 'XMLHttpRequest',
    }

    axiosUnauthorizedInterceptorHelper(instance)

    return instance
  }
  static async createAxiosInstanceWithCsrf() {
    const instance = axios.create({ ...this.params, withCredentials: true })
    await instance.get(CSRF_TOKEN_URL)

    axiosUnauthorizedInterceptorHelper(instance)

    return instance
  }
}
